export default __webpack_public_path__ + "static/AssetMynd-ef42220d83c7759ae48ed989f3cc301f.png";